import { getSysEnv } from '@vas2t-lowcode/utils';
import { defineStore } from 'pinia';
import { ref, UnwrapRef } from 'vue';

/**
 * 基础信息相关
 */
export const usePBaseStore = defineStore('base', () => {
  /**
   * 当前环境
   */
  const env = getSysEnv();
  // // APP的版本
  // appVersion: '1.0.0',
  // // APP的名称
  const appName = ref('lowcode');
  /**
   * 跳转到login前的页面
   */
  const appTheme = ref('white' as 'white' | 'dark');

  // /**
  //  * 设置app版本
  //  * @param version - 版本
  //  */
  // function setVersion(version) {
  //   appVersion.value = version;
  // },
  /**
   * 设置主题
   * @param theme - 当前主题
   */
  function setTheme(theme: UnwrapRef<typeof appTheme>) {
    appTheme.value = theme;
  }

  return {
    env,
    appName,
    appTheme,
    setTheme,
  };
});
